import React from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import LoginForm from './LoginForm';
import AssetsPage from './AssetsPage';
import './App.css';

const AppContent = () => {
  const { isLoggedIn } = useAuth();

  return (
    <div className="App pix">
      {isLoggedIn ? <AssetsPage /> : <LoginForm />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;